<template>
  <div :class="classes" :qa-locator-id="locators.set()">
    <img :src="iconPath" alt="" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useQaLocators } from '~/composables/use-qa-locators';

const COMPONENT_CLASS_NAME: string = 'icon-news';
const locators = useQaLocators(COMPONENT_CLASS_NAME);

const BASE = '/images/navigation-news';

// --- props ---
const props = defineProps({
  icon: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    validator: (value: string) => !value || ['xl', 'l', 'm', 's'].includes(value),
    default: 'l',
  },
  rounded: {
    type: Boolean,
    default: false,
  },
});

const iconPath = computed(() => `${BASE}/${props.icon}${props.rounded ? '-rounded' : ''}.png`);

const classes = computed(() => {
  return {
    [COMPONENT_CLASS_NAME]: true,
    [`size-${props.size}`]: true,
    rounded: props.rounded,
  };
});
</script>

<style lang="scss" scoped>
.icon-news {
  position: relative;
  display: flex;

  &.size-s {
    width: 16px;
    height: 16px;
  }
  &.size-m {
    width: 24px;
    height: 24px;
  }
  &.size-l {
    width: 32px;
    height: 32px;
  }
  &.size-xl {
    width: 40px;
    height: 40px;
  }
}
</style>
